<template>
<span>
     <!-- Error/Warn -->
            <div>
                <alert></alert>
            </div>
            <!-- /Error/Warn -->

    <productdetailhead></productdetailhead>

    <content>
      <div class="container">
        <productdetaildescription ref="productdesc"></productdetaildescription>
        <productdetailtab ref ="productdetail" ></productdetailtab>
      </div>
    </content>
    <div class="modal right fade" id="formModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog shadow-lg mx-0">
        <div class="modal-content rounded-0 border-0 pb-4">
          <button class="close ml-auto mt-3 mr-4" type="button" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">
              <svg class="icon icon-xs">
                <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg></span></button>
          <div class="modal-body"></div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="fullModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content rounded-0 border-0 shadow-lg">
          <div class="modal-header justify-content-end border-0">
            <button class="close ml-auto mt-1 mr-1" type="button" data-dismiss="modal" aria-label="Close" id="closeModalAccessories"><span aria-hidden="true">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></span></button>
          </div>
          <div class="modal-body" v-if="accessories.length>0"><accessories ref="add_from_productdetail"  parentID="productdetail" :parent_product="clickedproduct"></accessories></div>
          <div class="modal-footer justify-content-center border-0">
              <button class="btn btn-gray-50 text-white" type="reset" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{__('lang.btn.back')}}
              </button><a class="btn btn-primary border-0"  @click.prevent="$refs.add_from_productdetail.storeSelectedProducts()">{{__('lang.btn.tocart')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="accountModal" tabindex="-1" aria-hidden="true" v-show="session" ref="iframemodal">
      		<div class="modal-dialog modal-dialog-centered modal-xl">
        		<div class="modal-content rounded-0 border-0 shadow-lg">
          			<div class="modal-body p-1">
            			<div class="embed-responsive embed-responsive-16by9">
              				<iframe name="my_account" id="my_account" class="embed-responsive-item" :src="my_account_url" ></iframe>
            			</div>
       				</div>
        		</div>
      		</div>
   	</div>

</span>

</template>

<script>
    import productdetailhead  from './ProductDetailHead'
    import productdetaildescription  from './ProductDetailDescription'
    import productdetailtab  from './ProductDetailTab'
    //import operatingpoint  from './OperatingPoint'
    import accessories  from './Accessories'

    import userApi from './services/api/user'
    import alert from './Alert'





    export default {
        components: {
		        productdetailhead,
            productdetaildescription,
            productdetailtab,
      //      operatingpoint,
        accessories,
        alert

        },
        computed: {
          /* mediaData: function(){
            return this.$store.state.productdata.mediaData
          }, */
          product_data: function(){
            return this.$store.state.productdata.product_data
          },
          product_media:{
            get(){
              return this.$store.state.productdata.product_media
            }
          },
          accessories:{
            get(){
              return this.$store.state.productdata.accessories
            },
            set(value){
              this.$store.commit('productdata/setAccessories',value);

            }
          },
          url_params:function(){
            return this.$route.query
          },
         /*  operatingpoint_data: {
             get () {
                return this.$store.state.operatingpoint;
             }
          }, */
          clickedproduct:function(){
            var parentprod={}
            parentprod.refno=this.$store.state.productdata.product_data.ref_no
            parentprod.flag_fan=this.$store.state.productdata.product_data.flag_fan

            return parentprod
          },
          navigation: {
                get () {
                    return this.$store.state.globalData.navigation
                },
                set (value) {
                    this.$store.commit('globalData/updateNavigation', value)
                }
    	    },
          session: {
              get () {
                  return this.$store.state.user.session
              },
              set (value) {
                  this.$store.commit('user/updateSession', value)
              }
          },
          needLogin: {
              get () {
                  return this.$store.state.user.needLogin
              },
              set (value) {
                  this.$store.commit('user/updateNeedLogin', value)
              }
          },
          update: {
              get () {
                  return this.$store.state.globalData.update
              },
              set (value) {
                  this.$store.commit('globalData/updateUpdate', value)
              },
          },
          selectedlocale: {
            get() {
              return this.$store.state.user.selectedlocale
            },
            set(value) {
              this.$store.commit('user/updateSelectedlocale', value)
            }
          },
            applocales:{
                get() {
                    return this.$store.state.globalData.applocales
                },
                set(value) {
                    this.$store.commit('user/updateAppLocales', value)
                }


            }

        },
        data() {
          return {
            my_account_url: '',
            showAccountModal: false,
            mediaserver_url:'',//'https://globalstest.heliosventilatoren.de' ,
            countries: '{"DEU": "DE","AUT": "AT","FRA": "FR","___":"__"}',



          }

        },
  methods: {
        /* //kwleasyplan profilenavigationcomponent:
        async setIframeUrl(navigation) {
          if (!this.user.auth) {
            this.errorAlert(this.__("lang.error.need_registration"));
            return;
          }

          //window.enableLoadingAnimation();
          // we dont need this here because, the loading/waiting animation is not useful because we have no feedback, when the my account has been loaded

          setTimeout(async () => {
            try {
              // needs some more validation
              var response = await getAccessToken();

              if (!response.data.accessToken || response.data.accessToken == "") {
                // here we need to logout the user, because session is no longer valid
                this.$store.dispatch("session/clearTimer");
                this.$store.dispatch("session/resetState");
                window.disableLoadingAnimation();
                this.$store.dispatch("alert/setAlert", {
                  type: "info",
                  message:
                    "Sie wurden abgemeldet. Bitte melden Sie sich erneut an.",
                });
                return;
              }

              let url =
                this.session.myAccountLink +
                "/" +
                document.documentElement.lang +
                "?access_token=" +
                response.data.accessToken +
                "&target=" +
                navigation +
                "&service=" +
                response.data.service;
              if (url.startsWith("#")) {
                window.disableLoadingAnimation();
                this.errorAlert("Can not open My account");
                return;
              }
              this.openModal(url);
              window.disableLoadingAnimation();
            } catch (error) {
              window.disableLoadingAnimation();
            }
          }, 10);
        },


        window.sleep = (ms) => {
          return new Promise(resolve => setTimeout(resolve, ms));
        }

        window.enableLoadingAnimation = async () => {
          //console.log('enableLoadingAnimation');
          document.body.classList.add("is-loading");
          await window.sleep(50);
          //console.log('finished');
        };

        window.disableLoadingAnimation = async () => {
          //console.log('disableLoadingAnimation');
          document.body.classList.remove("is-loading");
          await window.sleep(50);
          //console.log('finished');
        };

        */
          setIframeUrl(){
                if(this.session != null){

                    axios.post('/user/access/token', {navigation: this.navigation}).then(response => {
            			this.my_account_url = response.data.url + '?access_token=' + response.data.access_token + '&language_id=1&target=' + response.data.navigation + '&service=1';// + response.data.service;
                        this.$bvModal.show('accountModal')
                        this.navigation = ''
                    }).catch(function (error) {
                       /* this.$store.dispatch("alert/setAlert", {
                          type: "info",
                          message:
                            this.__('lang.alert.session.timeout')
                        });
                       document.getElementById('closeAccountModal').click();

                        return;*/
                        this.navigation = ''




                    });
                }
          },

          openLogin () {
              this.needLogin = true;
          },
          fetchEventsList () {
              if(this.session && this.session.auth){
                  userApi.refreshSession();
              }
          },
          cancelAutoUpdate () {
              clearInterval(this.timer);
          },
          resetIframe(){
              this.my_account_url = ''
          },


          getMediaSrc: function(mediatype){

            for (var i = 0; i < this.product_media.length; i++) {
              if (this.product_media[i].media_type == mediatype && (this.product_media[i].path != '' && this.product_media[i].filename != '')) {
                //var mediadatapath=this.mediaData.filter(item => item.type == mediatype)[0]
                return this.mediaserver_url + this.product_media[i].path + this.product_media[i].filename
              }
              else return ''
              //console.log(this.product_data.product_media[i].path + '/' + this.product_data.product_media[i].filename)

            }
          },
          convertCountryIsoAlphas(code, alpha) {
              const allcountries = JSON.parse(this.countries);

              for (const [code3, code2] of Object.entries(allcountries)) {
                  if (code2.toUpperCase() === code.toUpperCase()) {
                      return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                  } else if (code3.toUpperCase() === code.toUpperCase()) {
                      return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                  }
              }

              return code.toLowerCase();
          },
      updateCountryLanguage(arg_country,arg_language) {
          /*20240523: new url structure de-de:*/
          var country;
          var language;
          var urlreplace_lang = false;

          const url = new URL(window.location);
          const pathname = url.pathname;

          // Create a URLSearchParams object from the URL's search parameters
          const urlparams = new URLSearchParams(url.search);
          const regex_countrylang = /^\/([a-z]{2,3})-([a-z]{2})(?:\/|$)/;
          const match_countrylang = pathname.match(regex_countrylang);

          if (match_countrylang) {
              const urlcountry = match_countrylang[1];
              const urllanguage = match_countrylang[2];
              country = this.convertCountryIsoAlphas(urlcountry, 3);
              language = urllanguage;

          } else {
              console.log('No match_countrylang found');
              const regex_lang = /^\/([a-z]{2})(?:\/|$)/;
              const match_lang = pathname.match(regex_lang);
              if (match_lang) {
                  const urllanguage = match_lang[1];
                  country = null
                  language = urllanguage;
                  urlreplace_lang = true;
              } else {
                  console.log('No match_lang found');
                  country = null
                  language = null;
              }
          }
          if (language == null || !this.applocales.available.languages.includes(language)) {
              if (this.selectedlocale.language && this.applocales.available.languages.includes(this.selectedlocale.language)) language = this.selectedlocale.language
              else language = this.applocales.fallback.language
          }
          if (country == null || !this.applocales.available.countries.includes(country)) {
              if (this.selectedlocale.country && this.applocales.available.countries.includes(this.selectedlocale.country)) country = this.selectedlocale.country
              else country = this.applocales.fallback.country
          }
          /*:new url structure de-de*/
          /*add old logic with language_id and country_id params*/

          if( language!=arg_language || country!=arg_country || urlreplace_lang){

              // Check if the parameter 'language_id' exists
              if (urlparams.has('language_id')) {
                  // If found, replace its value Prio de-de or language_id?  I take de-de!
                  urlparams.set('language_id', language);
              } else {
                  // If not found, add the parameter with the new value
                  urlparams.append('language_id',language);
              }
              if (urlparams.has('country_id')) {
                  // If found, replace its value Prio de-de or language_id?  I take de-de!
                  urlparams.set('country_id', country);
              } else {
                  // If not found, add the parameter with the new value
                  urlparams.append('country_id', country);
              }
              if(urlreplace_lang){
                  const replacementSegment = this.convertCountryIsoAlphas(country, 2) + '-' + language;
                  const segments = url.pathname.split('/');
                  // Replace the first non-empty segment
                  for (let i = 1; i < segments.length; i++) {
                      if (segments[i]) {
                          segments[i] = replacementSegment;
                          break;
                      }
                  }
                  // Reconstruct the pathname
                  url.pathname = segments.join('/');
              }


              // Store a flag in sessionStorage to indicate that the URL has been updated
              sessionStorage.setItem('producturlUpdated', 'true');
              // Update the URL with the new search parameters
              url.search = urlparams.toString();

              var params = { country: country, language:language }  //navigator.language,
              this.$root.$refs.proddetsticky.selected.country = country
              this.$root.$refs.proddetsticky.selected.language = language
              this.$store.commit('user/updateSelectedlocale', params)
              this.$lang().setLocale(language)
              window._locale =this.$lang().locale
              window._coutry = this.convertCountryIsoAlphas(country, 2)
              //now rewrite all to new url: domain/country-language/.....
              window.location.href = url.toString();

              //window.location.replace (url);
         }


      }


        },
        created() {

          //this.fetchEventsList();
          //this.timer = setInterval(this.fetchEventsList, 600000);

          //this.$store.dispatch('productdata/resetState')
          this.$store.dispatch('productdata/InitLoad', this.$route.query);

        // if(window.session_has_user==true){
        //     console.log('session_has_user getuserdata product detail view 123')
        //     axios.post('/user/basic/data').then(response => {
        //         this.session = true;
        //         console.log('Main this.user response data:')
        //         console.log(response.data)
        //
        //         this.user = response.data;
        //         this.getUserSettings()
        //         /*own articles if api set articles we don't need this:*/
        //         this.getUserArticles()
        //         this.getUserProject()
        //     }).catch((error) => {
        //         /*  console.log('error')
        //             console.log(error)
        //             this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.load_user_data_faild')}) */
        //     });
        // }
          /*
            console.log('vor dem obj keys.')
            console.log(Object.keys(this.$route.query))
            if ( Object.keys(this.$route.query).length != 0) this.$store.dispatch('productdata/InitLoad', this.$route.query);
            else {
              console.log('vor dem alert.')
              console.log(Object.keys(this.$route.query))
              this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.message.notfound') })

            }  */


        },
        mounted() {

            //this.$root.$refs.proddetsticky.setLocale(this.selectedlocale.country, this.$route.query.language_id);


            //this.$root.$refs.proddetsticky.selected = Object.assign({}, {})
            var language = !window._locale && !this.selectedlocale.language ? this.applocales.fallback.language : window._locale;
            var country = this.selectedlocale.country ?? this.applocales.fallback.country;

            // Check if the page has already been reloaded and the URL updated

            if (!sessionStorage.getItem('producturlUpdated')) {
                // If not, update the URL and reload the page
                this.updateCountryLanguage(country,language);
            } else {
                // If yes, remove the flag to reset for future use
                sessionStorage.removeItem('producturlUpdated');
            }

            $(this.$refs.iframemodal).on("hidden.bs.modal", this.resetIframe)



        },
        destroyed () {
            this.cancelAutoUpdate();
        },

        watch: {
            navigation:{
                deep:true,
                handler (){

                    if(this.navigation != '') this.setIframeUrl()
                },
            },
        }




    }

</script>
